import { useQuery } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { laborPerformanceService } from '../api/laborPerformance.service';
import { LABOR_PERFORMANCE_KEYS } from './queryKeys';
import type { PerformanceFilters } from '../types';

export function useLaborPerformanceTable(filters: PerformanceFilters) {
  const activeOrganizationId = useOrganizationStore((s) => s.activeOrganizationId);

  return useQuery({
    queryKey: LABOR_PERFORMANCE_KEYS.table(activeOrganizationId ?? '', filters),
    queryFn: ({ signal }) => laborPerformanceService.getTable(filters, signal),
    staleTime: 5 * 60 * 1000,
    enabled: !!activeOrganizationId && !!filters.periodStart && !!filters.periodEnd,
  });
}
